import React from 'react';

import { useLiveStreamContext } from 'client/components/LiveStreamConnector/context';
import wakeLock from 'client/utils/wake-lock';

import Participant from './Participant';

import css from './Room.module.scss';

export const Room: React.FC = () => {
  const { state } = useLiveStreamContext();

  React.useEffect(() => {
    return () => {
      wakeLock.release();
    };
  }, []);

  return (
    <div className={css.room}>
      {state.localParticipant && (
        <Participant key={state.localParticipant.identity} participant={state.localParticipant} />
      )}

      {state.participants.map((participant) => {
        return <Participant key={participant.identity} participant={participant} />;
      })}
    </div>
  );
};
